module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/icon_instagram-bdec7857bf0a42c771d0499384eece9b.png";